import React, { Component } from "react";
import { Button, ButtonToolbar, DropdownButton, MenuItem, Modal } from "react-bootstrap";
import Alert from 'react-s-alert';
import DealActions from '../Actions/dealActions';
import DealStatuses from '../Actions/dealStatuses';
import AuthContext from '../auth-context';
import SetupCoachingPortalModal from '../Coaching/SetupCoachingPortalModal';
import ConfirmButton from '../Shared/ConfirmButton';
import DealsService from '../utils/DealsService';
import ReferenceService from '../utils/ReferenceService';
import AddNoteModal from './AddNoteModal';
import CancelModal from '../TCS/CancelModal';
import CreateLeadModal from './CreateLeadModal';
import NoSaleModal from './NoSaleModal';
import PutOnHoldModal from './PutOnHoldModal';
import ReviewSaleModal from './ReviewSaleModal';
import SaleMadeModal from './SaleMadeModal';
import VerifySaleModal from './VerifySaleModal';

class DealButtonBar extends Component {
  static contextType = AuthContext;

  state = {
    messageAudience: 'primary'
  }

  componentDidMount() {
    ReferenceService.get('sms_group_messages').then(data => {
      this.setState({ smsGroupMessages: data })
    });
    ReferenceService.get('email_group_messages').then(data => {
      this.setState({ emailGroupMessages: data })
    });
  }

  handleConfirmModal = (response) => {
    this.closeModals()
    if (this.props.handleDealUpdated && response.deal) this.props.handleDealUpdated(response.deal)
  }

  closeModals = () => {
    this.setState({ showMessageModal: false, showModalSaleMade: false, showModalUpgradeMade: false, showModalNoSale: false, showModalCancelled: false, showModalVerifySale: false, showModalVerifyUpgrade: false, showModalReviewSale: false, showModalDeadDeal: false, showModalAddNote: false, showModalPutOnHold: false, showModalEdit: false, showModalCreateLead: false, showModalSetupCoachingPortal: false })
  }

  showMessageModal = (type, index, item) => {
    this.setState({ showMessageModal: true, modalMessageType: type, modalMessageIndex: index, modalMessageItem: item });
  }

  sendMessage = (testMode) => {
    const params = { deal_ids: [this.props.deal.id], message_type: this.state.modalMessageType, message_item: this.state.modalMessageItem, test_mode: testMode, audience: this.state.messageAudience }
    DealsService.sendGroupMessage(params)
      .then((response) => {
        Alert.success('Sent message OK')
        this.closeModals()
      })
      .catch((response) => { Alert.error(`<h1>Error sending message</h1><p>${response.data.message}</p>`, { html: true, timeout: 10000 }) })
  }

  deleteDeal = () => {
    const { deal } = this.props
    const actions = new DealActions(deal)
    actions.deleteDeal()
  }

  render() {
    const { deal } = this.props
    const authStore = this.context

    const dealStatuses = new DealStatuses(deal, authStore)
    const showButtons = dealStatuses.dealStatuses.buttons

    return (
      <div style={{ marginTop: 6 }}>
        <ButtonToolbar>
          {showButtons.saleMade && <Button style={{ marginBottom: 2 }} bsStyle="info" bsSize="xsmall" onClick={() => this.setState({ showModalSaleMade: true })}>Sale Made</Button>}
          {showButtons.upgradeMade && <Button style={{ marginBottom: 2 }} bsStyle="info" bsSize="xsmall" onClick={() => this.setState({ showModalUpgradeMade: true })}>Upgrade Made</Button>}
          {showButtons.noSale && <Button style={{ marginBottom: 2 }} bsStyle="info" bsSize="xsmall" onClick={() => this.setState({ showModalNoSale: true })}>No Sale</Button>}
          {showButtons.cancelled && <Button style={{ marginBottom: 2 }} bsStyle="warning" bsSize="xsmall" onClick={() => this.setState({ showModalCancelled: true })}>Cancel</Button>}
          {showButtons.verifySale && <Button style={{ marginBottom: 2 }} bsStyle="info" bsSize="xsmall" onClick={() => this.setState({ showModalVerifySale: true })}>Verify Sale</Button>}


          {showButtons.showSetupPortal && showButtons.setupCoachingPortal && <Button style={{ marginBottom: 2 }} bsStyle="info" bsSize="xsmall" onClick={() => this.setState({ showModalSetupCoachingPortal: true })}>Setup Coaching</Button>}
          {showButtons.verifyUpgrade && <Button style={{ marginBottom: 2 }} bsStyle="info" bsSize="xsmall" onClick={() => this.setState({ showModalVerifyUpgrade: true })}>Verify Upgrade</Button>}
          {showButtons.reviewSale && <Button style={{ marginBottom: 2 }} bsStyle="info" bsSize="xsmall" onClick={() => this.setState({ showModalReviewSale: true })}>Approve / Decline Sale</Button>}
          {showButtons.deadDeal && <Button style={{ marginBottom: 2 }} bsStyle="info" bsSize="xsmall" onClick={() => this.setState({ showModalDeadDeal: true })}>Dead Deal</Button>}

          {<Button style={{ marginBottom: 2, marginLeft: 20 }} bsStyle="info" bsSize="xsmall" onClick={() => this.setState({ showModalAddNote: true })}>Add Note</Button>}
          {showButtons.putOnHold && <Button style={{ marginBottom: 2 }} bsStyle="info" bsSize="xsmall" onClick={() => this.setState({ showModalPutOnHold: true })}>Put On Hold</Button>}

          {<Button style={{ marginBottom: 2 }} bsStyle="info" bsSize="xsmall" onClick={() => this.setState({ showModalCreateLead: true })}>Follow Up</Button>}
          {authStore.anyRoles(['super_admin']) &&
            <ConfirmButton
              text='Delete Deal'
              message="This will PERMANENTLY and UNRECOVERABLY delete this deal and all traces of it. Be absolutely sure you want to do this. LeadMachine Contacts and Tasks will NOT automatically be updated"
              hideNote={true}
              style={{ marginBottom: 2 }} bsStyle="danger"
              okAction={() => this.deleteDeal()} />}

          <DropdownButton
            bsStyle='info'
            bsSize='xsmall'
            title='Email'
            key='1'
            id='dropdown-group-actions'
          >
            {this.state.emailGroupMessages && this.state.emailGroupMessages.map((item, index) =>
              <MenuItem key={index} eventKey={index} id={item.id} onClick={() => this.showMessageModal('email', index, item)}>{item.description}</MenuItem>
            )}
          </DropdownButton>
          <DropdownButton
            bsStyle='info'
            bsSize='xsmall'
            title='SMS'
            key='2'
            id='dropdown-group-actions'
          >
            {this.state.smsGroupMessages && this.state.smsGroupMessages.map((item, index) =>
              <MenuItem key={index} eventKey={index} id={item.template_text} onClick={() => this.showMessageModal('sms', index, item)}>{item.description}</MenuItem>
            )}
          </DropdownButton>
        </ButtonToolbar>

        <SaleMadeModal showModal={this.state.showModalSaleMade} deal={deal} saleType='sale' onConfirmModal={this.handleConfirmModal} onCloseModal={() => this.closeModals()} />
        <SaleMadeModal showModal={this.state.showModalUpgradeMade} deal={deal} saleType='upgrade' onConfirmModal={this.handleConfirmModal} onCloseModal={() => this.closeModals()} />

        <NoSaleModal showModal={this.state.showModalNoSale} deal={deal} noSaleType='no_sale' onConfirmModal={this.handleConfirmModal} onCloseModal={() => this.closeModals()} />
        <CancelModal showModal={this.state.showModalCancelled} deal={deal} onConfirmModal={this.handleConfirmModal} onCloseModal={() => this.closeModals()} />
        <NoSaleModal showModal={this.state.showModalDeadDeal} deal={deal} noSaleType='dead_deal' onConfirmModal={this.handleConfirmModal} onCloseModal={() => this.closeModals()} />

        <ReviewSaleModal showModal={this.state.showModalReviewSale} deal={deal} onConfirmModal={this.handleConfirmModal} onCloseModal={() => this.closeModals()} />
        <VerifySaleModal showModal={this.state.showModalVerifySale} deal={deal} reviewType='sale' onConfirmModal={this.handleConfirmModal} onCloseModal={() => this.closeModals()} />
        <VerifySaleModal showModal={this.state.showModalVerifyUpgrade} deal={deal} reviewType='upgrade' onConfirmModal={this.handleConfirmModal} onCloseModal={() => this.closeModals()} />

        <SetupCoachingPortalModal showModal={this.state.showModalSetupCoachingPortal} deal={deal} onConfirmModal={this.handleConfirmModal} onCloseModal={() => this.closeModals()} />

        <AddNoteModal showModal={this.state.showModalAddNote} deal={deal} onConfirmModal={this.handleConfirmModal} onCloseModal={() => this.closeModals()} />
        <PutOnHoldModal showModal={this.state.showModalPutOnHold} deal={deal} onConfirmModal={this.handleConfirmModal} onCloseModal={() => this.closeModals()} />

        <CreateLeadModal showModal={this.state.showModalCreateLead} deal={deal} onConfirmModal={this.handleConfirmModal} onCloseModal={() => this.closeModals()} />

        <Modal show={this.state.showMessageModal} onHide={this.handleConfirmModal}>
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalMessageType} : {this.state.showMessageModal && this.state.modalMessageItem.description}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              This will send an {this.state.modalMessageType} message to this Deal
            </p>
            <div className='form-group'>
              <label>Send To</label>
              <select className="form-control input-sm" value={this.state.messageAudience} onChange={(e) => this.setState({ messageAudience: e.target.value })}>
                <option value='primary'>Primary Contact</option>
                <option value='all'>All Contacts</option>
                <option value='parents'>All Parent Contacts</option>
                <option value='students'>All Student Contacts</option>
              </select>
            </div>

          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeModals} bsSize='small'>Close</Button>
            <Button bsStyle='primary' bsSize='small' onClick={() => this.sendMessage(false)}>Send the message</Button>
          </Modal.Footer>
        </Modal>

      </div>
    )
  }
}

export default DealButtonBar
